import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMasterDashboard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 37,
	viewBox: "0 0 36 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Master Dashboard",
		d: "M25.5547 0.046875H10.4632C3.90795 0.046875 0 3.95482 0 10.5101V25.5836C0 32.1569 3.90795 36.0648 10.4632 36.0648H25.5367C32.092 36.0648 35.9999 32.1569 35.9999 25.6016V10.5101C36.0179 3.95482 32.11 0.046875 25.5547 0.046875ZM12.8044 26.8802C12.8044 27.3845 12.4082 27.7807 11.9039 27.7807H6.87943C6.37518 27.7807 5.97898 27.3845 5.97898 26.8802V18.5601C5.97898 17.4255 6.89744 16.5071 8.032 16.5071H11.9039C12.4082 16.5071 12.8044 16.9033 12.8044 17.4075V26.8802ZM21.4127 26.8802C21.4127 27.3845 21.0165 27.7807 20.5122 27.7807H15.4877C14.9835 27.7807 14.5873 27.3845 14.5873 26.8802V10.384C14.5873 9.24946 15.5057 8.331 16.6403 8.331H19.3777C20.5122 8.331 21.4307 9.24946 21.4307 10.384V26.8802H21.4127ZM30.039 26.8802C30.039 27.3845 29.6428 27.7807 29.1385 27.7807H24.114C23.6098 27.7807 23.2136 27.3845 23.2136 26.8802V20.4871C23.2136 19.9828 23.6098 19.5866 24.114 19.5866H27.9859C29.1205 19.5866 30.039 20.5051 30.039 21.6396V26.8802Z",
		fill: "currentColor"
	})
});
export default SvgMasterDashboard;
